<template>
  <WatchProvidersForm :profile="profile" @close="closeAndRedirect" />
</template>

<script setup>
import WatchProvidersForm from '@/components/user/WatchProvidersForm'

const props = defineProps({
  profile: Object
})

const emit = defineEmits(['close'])

const closeAndRedirect = () => {
  emit('close')
}
</script>
